import { Grid, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import PricingCard from '@/components/PricingCard';

export default function TicketCards({ activeEvent }) {
  const { t } = useTranslation();

  const superEarlyBirdEnded = new Date() > new Date(activeEvent.superEarlyBirdEndAt);
  const earlyBirdEnded = new Date() > new Date(activeEvent.earlyBirdEndAt);
  const presaleEnded = new Date() > new Date(activeEvent.presaleBirdEndAt);

  return (
    <Grid container id="ticket-section" spacing={1} sx={{ height: '100%', py: 8 }}>
      <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }} size={12}>
        <Typography variant="h2" textAlign="center" className="font-bebas">
          {t('ticket.title')}
        </Typography>
      </Grid>
      {/* SUPER EARLY BIRD */}
      {!superEarlyBirdEnded && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <PricingCard
            promote
            title={t('ticket.superearlybird')}
            description={format(parseISO(activeEvent.superEarlyBirdEndAt), 'yyyy-MM-dd')}
            price={activeEvent.superEarlyBirdPrice}
            url={t('ticket.superearlybird.link')}
            perks={[
              t('ticket.superearlybird.perk'),
              t('ticket.superearlybird.perk2'),
              t('ticket.superearlybird.perk3'),
              t('ticket.superearlybird.perk4'),
            ]}
          />
        </Grid>
      )}
      {/* EARLY BIRD */}
      {superEarlyBirdEnded && !earlyBirdEnded && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <PricingCard
            promote
            title={t('ticket.earlybird')}
            description={format(parseISO(activeEvent.earlyBirdEndAt), 'yyyy-MM-dd')}
            price={activeEvent.earlyBirdPrice}
            url={t('ticket.earlybird.link')}
            perks={[
              t('ticket.earlybird.perk'),
              t('ticket.earlybird.perk2'),
              t('ticket.earlybird.perk3'),
              t('ticket.earlybird.perk4'),
            ]}
          />
        </Grid>
      )}
      {/* PRESALE BIRD */}
      {superEarlyBirdEnded && earlyBirdEnded && !presaleEnded && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <PricingCard
            promote
            title={t('ticket.presale')}
            description={format(parseISO(activeEvent.presaleBirdEndAt), 'yyyy-MM-dd')}
            price={activeEvent.presaleBirdPrice}
            url={t('ticket.presale.link')}
            perks={[
              t('ticket.presale.perk'),
              t('ticket.presale.perk2'),
              t('ticket.presale.perk3'),
              t('ticket.presale.perk4'),
            ]}
          />
        </Grid>
      )}
      {/* WEEKEND BIRD */}
      {superEarlyBirdEnded && earlyBirdEnded && presaleEnded && (
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <PricingCard
            promote
            title={t('ticket.weekend')}
            description=""
            price={activeEvent.weekendPrice}
            url={t('ticket.weekend.link')}
            perks={[
              t('ticket.weekend.perk'),
              t('ticket.weekend.perk2'),
              t('ticket.weekend.perk3'),
              t('ticket.weekend.perk4'),
            ]}
          />
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 6, lg: 3 }}>
        <PricingCard
          title={t('ticket.friday')}
          description=""
          price={activeEvent.fridayPrice}
          url={t('ticket.friday.link')}
          perks={[
            t('ticket.friday.perk'),
            t('ticket.friday.perk2'),
            t('ticket.friday.perk3'),
            t('ticket.friday.perk4'),
          ]}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 3 }}>
        <PricingCard
          title={t('ticket.saturday')}
          description=""
          price={activeEvent.saturdayPrice}
          url={t('ticket.saturday.link')}
          perks={[
            t('ticket.saturday.perk'),
            t('ticket.saturday.perk2'),
            t('ticket.saturday.perk3'),
            t('ticket.saturday.perk4'),
          ]}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 3 }}>
        <PricingCard
          title={t('ticket.sunday')}
          description=""
          price={activeEvent.sundayPrice}
          url={t('ticket.sunday.link')}
          perks={[
            t('ticket.sunday.perk'),
            t('ticket.sunday.perk2'),
            t('ticket.sunday.perk3'),
            t('ticket.sunday.perk4'),
          ]}
        />
      </Grid>
    </Grid>
  );
}

TicketCards.propTypes = {
  activeEvent: PropTypes.object.isRequired,
};
